import { gql } from '@apollo/client';

import { BeneficiaryFields } from './beneficiary.fragment';

export * from './beneficiaryCreate.mutation.generated';

export const BENEFICIARY_CREATE = gql`
  ${BeneficiaryFields}
  mutation beneficiaryCreate($escrowId: ID!, $beneficiaryParams: EscrowPartyParams!) {
    beneficiaryCreate(input: { escrowId: $escrowId, beneficiaryParams: $beneficiaryParams }) {
      success
      errors
      beneficiary {
        escrow {
          id
          beneficiaryConfigured
          beneficiary {
            ...BeneficiaryFields
          }
          ... on SoftwareEscrow {
            policy {
              createBeneficiary
            }
          }
        }
      }
    }
  }
`;
